import React from 'react'
import { UncontrolledTooltip } from 'reactstrap'

// Wrapper component to fix React 18 transition.timeout issue.
// NOTE (#635): converts to corebyscott's Tooltip (target-id mode) together with
// its host pages (Header/PageView/ActivityFeed) — core's tip portals to <body>,
// which is outside prioritize's `.cbs-scope`, so it needs those pages migrated
// (or cbs-scope retired at teardown) to be styled. Deferred to the page pass.
const Tooltip = ({ transition, ...props }) => {
  return (
    <UncontrolledTooltip
      {...props}
      transition={transition || { timeout: 150 }}
    />
  )
}

export default Tooltip
